import { FiFileText } from "react-icons/fi";
import { RowMenu } from "../rowMenu";
import { BiPencil } from "react-icons/bi";
import { BsTrash2 } from "react-icons/bs";

export const SidebarArticleRow = ({ article, isSelected, onSelect, onEdit, onDelete }) => {
  return (
    <div
      onClick={onSelect}
      className={`group flex cursor-pointer items-center justify-between gap-2 rounded-md px-2 py-1.5 pl-9 text-sm transition-colors ${
        isSelected ? "bg-cyan-50 text-cyan-800 font-medium" : "text-slate-600 hover:bg-slate-100"
      }`}
    >
      <div className="flex min-w-0 items-center gap-2">
        <FiFileText size={14} className="shrink-0 opacity-70" />
        <span className="truncate">{article.title}</span>
      </div>
      <div className="opacity-0 group-hover:opacity-100">
        <RowMenu
          items={[
            { label: "Edit article", icon: <BiPencil size={13} />, onClick: onEdit },
            { label: "Delete article", icon: <BsTrash2 size={13} />, onClick: onDelete, danger: true },
          ]}
        />
      </div>
    </div>
  );
}